import { PopoverMenuComponent } from 'commons/components';
import { CustomAlarmListItem } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';
import { useCustomAlarmsList } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/hooks/use-custom-alarms-list/use-custom-alarms-list.hook';
import { CustomAlarmActivateCommandComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/commands/custom-alarm-activate-command.component';
import { CustomAlarmDeactivateCommandComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/commands/custom-alarm-deactivate-command.component';
import { CustomAlarmDeleteCommandComponent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/commands/custom-alarm-delete-command.component';

export interface CustomAlarmRowOptionsComponentProps {
    customAlarm: CustomAlarmListItem;
}

export const CustomAlarmRowOptionsComponent: React.FC<CustomAlarmRowOptionsComponentProps> = (props) => {
    const { customAlarm } = props;
    const { showDeleteConfirmationModal, showDeactivateConfirmationModal, showActivateConfirmationModal } =
        useCustomAlarmsList();

    return (
        <PopoverMenuComponent
            data-testid={`custom-alarm-row-options-${customAlarm.id}`}
            anchor={`custom-alarm-row-options-${customAlarm.id}`}
        >
            {customAlarm.active ? (
                <CustomAlarmDeactivateCommandComponent onClick={() => showDeactivateConfirmationModal([customAlarm])} />
            ) : (
                <CustomAlarmActivateCommandComponent onClick={() => showActivateConfirmationModal([customAlarm])} />
            )}
            <CustomAlarmDeleteCommandComponent onClick={() => showDeleteConfirmationModal([customAlarm])} />
        </PopoverMenuComponent>
    );
};
